<div class="container_width flex flex-column gap-4" style="padding-top:16px; padding-bottom:24px;">

  <!-- Mentor context: Back to Student Profile banner -->
  <div *ngIf="applicantId"
    class="w-full flex align-items-center justify-content-between px-4 py-3 border-round-xl"
    style="background: linear-gradient(90deg, #000086 0%, #1a1ab0 100%); box-shadow: 0 2px 8px rgba(0,0,134,0.18);">
    <div class="flex align-items-center gap-3">
      <i class="pi pi-user-edit" style="color:#CDD12A; font-size:1.3rem;"></i>
      <span class="font-semibold text-white text-base">
        Adding college for student
        <span *ngIf="applicantDetails?.firstName" style="color:#CDD12A;">
          {{ applicantDetails?.firstName }} {{ applicantDetails?.lastName }}
        </span>
      </span>
    </div>
    <button
      (click)="router.navigate(['/mentor-portal/app-applicant-profile', applicantId])"
      style="background:#CDD12A; color:#12263F; border:none; border-radius:8px; padding:8px 20px; font-weight:700; font-size:14px; cursor:pointer; display:flex; align-items:center; gap:8px; transition:opacity 0.2s;"
      onmouseover="this.style.opacity='0.85'" onmouseout="this.style.opacity='1'">
      <i class="pi pi-arrow-left"></i> Back to Student Profile
    </button>
  </div>

  <div class="flex gap-4 align-items-start w-full">
    <!-- Left Sidebar Column -->
    <div style="width:255px; flex-shrink:0; display:flex; flex-direction:column; gap:24px;">
      
      <div class="w-full block" *ngIf="activeTab !== 'scholarships'">
        <!-- Top blue navigation box for Universities/Programmes -->
        <div style="background-color: #000086; padding: 24px 16px; border-radius: 12px; display: flex; flex-direction: column; gap: 12px; box-shadow: 0 4px 12px rgba(0,0,134,0.15); font-family: 'Circular Std', sans-serif;">
          <button (click)="toggleMyInstitutesMode(false)"
                  [style.background-color]="!myInstitutesOnly ? '#fff' : 'transparent'"
                  [style.color]="!myInstitutesOnly ? '#000086' : '#fff'"
                  style="width: 100%; padding: 12px; border-radius: 8px; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: flex-start; gap: 12px; cursor: pointer; border: none; transition: all 0.2s; font-family: 'Circular Std', sans-serif;">
            <i class="pi pi-search" [style.color]="!myInstitutesOnly ? '#000086' : '#fff'"></i> College Search
          </button>
          <button (click)="toggleMyInstitutesMode(true)"
                  [style.background-color]="myInstitutesOnly ? '#fff' : 'transparent'"
                  [style.color]="myInstitutesOnly ? '#000086' : '#fff'"
                  style="width: 100%; padding: 12px; border-radius: 8px; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: flex-start; gap: 12px; cursor: pointer; border: none; transition: all 0.2s; font-family: 'Circular Std', sans-serif;">
            <i class="pi pi-bookmark" [style.color]="myInstitutesOnly ? '#000086' : '#fff'"></i> {{ activeTab === 'programmes' ? 'Saved Programmes' : 'Saved Colleges' }}
          </button>
        </div>
      </div>

      <app-institute-serach-filter *ngIf="activeTab !== 'scholarships'" #filterComponent (onApplyingFilter)="searchDetailInstitutes($event)"
        [activeTab]="activeTab" [myInstitutesOnly]="myInstitutesOnly"
        [allUniversitiesCount]="allUniversitiesCount"
        [partnerUniversitiesCount]="partnerUniversitiesCount"
        [isDAPartner]="instituteSearchRequest?.isDAPartner || false">
      </app-institute-serach-filter>

      <!-- Show scholarship filters if activeTab === 'scholarships' -->
      <div *ngIf="activeTab === 'scholarships'" class="flex flex-column gap-3" style="font-family: 'Karla', sans-serif;">
        <!-- Top blue navigation box -->
        <div style="background-color: #060b29; padding: 24px 16px; border-radius: 12px; display: flex; flex-direction: column; gap: 12px; box-shadow: 0 4px 12px rgba(6,11,41,0.15);">
          <button (click)="activeTab = 'scholarships'; firstItem = 0; myScholarshipsOnly = false; getScholarships()"
                  [style.background-color]="!myScholarshipsOnly ? '#fff' : 'transparent'"
                  [style.color]="!myScholarshipsOnly ? '#060b29' : '#fff'"
                  [style.border]="!myScholarshipsOnly ? '1.5px solid #fff' : '1.5px solid transparent'"
                  style="width: 100%; padding: 12px; border-radius: 8px; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: flex-start; gap: 12px; cursor: pointer; transition: all 0.2s; font-family: 'Circular Std', sans-serif;">
            <i class="pi pi-search" [style.color]="!myScholarshipsOnly ? '#060b29' : '#fff'"></i> Scholarship Search
          </button>
          <button (click)="toggleMyScholarshipsMode(!myScholarshipsOnly)"
                  [style.background-color]="myScholarshipsOnly ? '#fff' : 'transparent'"
                  [style.color]="myScholarshipsOnly ? '#060b29' : '#fff'"
                  [style.border]="myScholarshipsOnly ? '1.5px solid #fff' : '1.5px solid transparent'"
                  style="width: 100%; padding: 12px; border-radius: 8px; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: flex-start; gap: 12px; cursor: pointer; transition: all 0.2s; font-family: 'Circular Std', sans-serif;">
            <i class="pi pi-heart" [style.color]="myScholarshipsOnly ? '#060b29' : '#fff'"></i> Saved Scholarship
          </button>
        </div>

        <!-- Filter Options container -->
        <div class="filter-sidebar bg-white border-round-2xl p-4 shadow-1 h-full" style="border: 1px solid #f1f5f9; display: flex; flex-direction: column; gap: 24px;">
          <h3 class="font-bold text-2xl m-0 mb-2" style="color: #000; font-family: 'Circular Std', sans-serif;">Filter</h3>

          <!-- Country Filter -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> COUNTRY
            </h5>
            <p-multiSelect [options]="countryFilterOptions" [(ngModel)]="selectedCountries" placeholder="Select a country"
              class="w-full" styleClass="w-full text-sm custom-dropdown" display="chip"></p-multiSelect>
          </div>

          <!-- Degree Level Filter -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> DEGREE LEVEL
            </h5>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let opt of degreeLevelOptions" (click)="toggleLevelFilter(opt)"
                      class="p-link pill-btn" [class.active]="selectedLevels.includes(opt)">
                {{ opt }}
              </button>
            </div>
          </div>

          <!-- Academic Eligibility -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">


              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> ACADEMIC ELIGIBILITY <span class="ml-auto" style="color: #475569;">{{ selectedAcademicEligibility || 0 }}%</span>
            </h5>
            <div class="px-2 mt-4 mb-2">
              <p-slider [(ngModel)]="selectedAcademicEligibility" [min]="0" [max]="100" styleClass="custom-slider"></p-slider>
            </div>
            <div class="flex justify-content-between text-xs font-bold text-gray-800">
              <span>0</span>
              <span style="color: #0b117b; font-weight: 800;">{{ selectedAcademicEligibility }}%</span>
              <span>100%</span>
            </div>
          </div>

          <!-- Funding Type -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> FUNDING TYPE
            </h5>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let type of fundingTypeOptionsAll" (click)="toggleFundingTypeFilter(type)"
                      class="p-link pill-btn" [class.active]="selectedFundingTypes.includes(type)">
                {{ type }}
              </button>
            </div>
          </div>

          <!-- Field of Study -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> FIELD OF STUDY
            </h5>
            <p-multiSelect [options]="fieldsOfStudyOptions" [(ngModel)]="selectedFieldsOfStudy" placeholder="Select a field of study"
              class="w-full" styleClass="w-full text-sm custom-dropdown" display="chip"></p-multiSelect>
          </div>

          <!-- Stream Filter -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> STREAM
            </h5>
            <p-multiSelect [options]="streamFilterOptions" [(ngModel)]="selectedStreams" placeholder="Select a stream"
              class="w-full" styleClass="w-full text-sm custom-dropdown" display="chip"></p-multiSelect>
          </div>

          <!-- Levels (Study Mode) Filter -->
          <!-- <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px; font-family: 'Circular Std', sans-serif;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> STUDY MODE
            </h5>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let mode of ['In person', 'Online', 'In person & Online', 'Virtual']" (click)="toggleModeFilter(mode)"
                      class="p-link pill-btn" [class.active]="selectedModes.includes(mode)">
                {{ mode }}
              </button>
            </div>
          </div> -->

          <!-- Action Buttons -->
          <div class="flex gap-2 mt-4 pt-3" style="border-top: 1px solid #f1f5f9; font-family: 'Circular Std', sans-serif;">
            <button class="p-link reset-btn flex-1 py-3 border-round-xl font-bold text-center transition-colors text-sm"
                    style="border: 1px solid #e2e8f0; color: #475569; background: #ffffff; cursor: pointer; border-radius: 12px;"
                    onmouseover="this.style.background='#f8fafc'"
                    onmouseout="this.style.background='#ffffff'"
                    (click)="resetFilters()">
              Reset
            </button>
            <button class="p-link apply-btn flex-1 py-3 border-round-xl font-bold text-center transition-colors text-sm text-white"
                    style="background: #0b117b; border: none; cursor: pointer; border-radius: 12px;"
                    onmouseover="this.style.background='#1e293b'"
                    onmouseout="this.style.background='#0b117b'"
                    (click)="applyScholarshipFilters()">
              Apply
            </button>
          </div>

        </div>
      </div>
      
    </div>
    <div class="flex-1 min-w-0 flex flex-column gap-0">
      <div style="border-bottom:1px solid #e8edf2; margin-bottom:24px;">
        <div style="display:flex; align-items:flex-end; gap:32px;">
          <button (click)="switchTab('universities')"
            style="padding:10px 0; font-size:16px; font-weight:700; border:none; background:transparent; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-1px; transition:all 0.15s;"
            [style.color]="activeTab==='universities' ? '#0f172a' : '#64748b'"
            [style.border-bottom-color]="activeTab==='universities' ? '#1e1b4b' : 'transparent'">
            Universities
          </button>
          <button (click)="switchTab('programmes')"
            style="padding:10px 0; font-size:16px; font-weight:700; border:none; background:transparent; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-1px; transition:all 0.15s;"
            [style.color]="activeTab==='programmes' ? '#0f172a' : '#64748b'"
            [style.border-bottom-color]="activeTab==='programmes' ? '#1e1b4b' : 'transparent'">
            Programmes
          </button>
          <button (click)="switchTab('scholarships')"
            style="padding:10px 0; font-size:16px; font-weight:700; border:none; background:transparent; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-1px; transition:all 0.15s;"
            [style.color]="activeTab==='scholarships' ? '#0f172a' : '#64748b'"
            [style.border-bottom-color]="activeTab==='scholarships' ? '#1e1b4b' : 'transparent'">
            Scholarships
          </button>
        </div>
      </div>

      <div *ngIf="activeTab !== 'scholarships'" style="margin-bottom: 24px; padding-left: 6px; padding-bottom: 6px;">
        <span class="p-input-icon-left w-full" style="box-shadow: -6px 6px 0px 0px #ede9fe; border-radius: 8px; display: block; border: 1px solid #e2e8f0; background: #fff;">
          <i class="pi pi-search" style="color: #8b5cf6;"></i>
          <p-autoComplete [suggestions]="searchSuggestions" [(ngModel)]="collegeSearchName"
            [style]="{'width':'100%', 'height':'54px'}" 
            [inputStyle]="{'width':'100%', 'height':'54px', 'border-radius':'8px', 'padding-left':'40px', 'border':'none', 'color':'#8b5cf6', 'font-size':'16px'}" 
            [panelStyle]="{'width':'100%'}"
            panelStyleClass="search-panel" (completeMethod)="onSearchComplete($event)" optionLabel="name"
            placeholder="Search" (onClear)="onSearchClear()"
            (onSelect)="onSearchSelect()" (keyup.enter)="onSearchEnter()"
            styleClass="autocomp-full-width w-full block" class="w-full block custom-purple-placeholder" />
        </span>
      </div>

      <div *ngIf="activeTab !== 'scholarships'" style="display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:24px;">
        <div>
          <div style="font-size:18px; font-weight:600; color:#8E8EF1; margin-bottom:12px;">
            {{ (activeTab === 'programmes' ? totalProgrammes : totalUniversities) | number }} {{ activeTab === 'programmes' ? 'Programmes' : 'Universities' }} found
          </div>
          <div *ngIf="(filterComponent?.allActiveFilters?.length || 0) > 0" style="display:flex; flex-wrap:wrap; gap:8px;">
            <span *ngFor="let filter of filterComponent?.allActiveFilters || []" style="background:#cddb29; color:#0b117b; padding:4px 12px; border-radius:16px; font-size:12px; font-weight:600; display:flex; align-items:center; gap:6px; border: 1px solid rgba(11, 17, 123, 0.15);">
              {{ filter.label }} <i class="pi pi-times" style="font-size:10px; cursor:pointer;" (click)="filterComponent?.removeActiveFilter(filter)"></i>
            </span>
          </div>
        </div>
        <div style="display:flex; align-items:center; gap:12px;">
          <p-dropdown [options]="sortlistOptions" [(ngModel)]="sortField" (onChange)="onSortChange()" optionLabel="name"
            placeholder="Sort by Select.." styleClass="sort-dropdown-custom">
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div style="display: flex; align-items: center; gap: 5px;">
                <span>Sort by</span>
                <span>{{selectedOption.name}}</span>
              </div>
            </ng-template>
          </p-dropdown>
          
          <p-dropdown [options]="sortOrderOptions" [(ngModel)]="sortOrder" (onChange)="onSortChange()"
            optionLabel="name" placeholder="Order" styleClass="sort-dropdown-custom">
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div style="display: flex; align-items: center; gap: 5px;">
                <span>{{selectedOption ? selectedOption.name : 'Order'}}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <!-- Heading & Sort row for Scholarships Tab -->
      <div *ngIf="activeTab === 'scholarships'" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; font-family: 'Circular Std', sans-serif;">
        <span style="font-size: 16px; font-weight: 700; color: #4361ee;">
          {{ totalScholarships | number }} {{ myScholarshipsOnly ? 'Saved Scholarships' : 'Scholarships' }} found
        </span>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button (click)="sortMenu.toggle($event)" 
                  style="background-color: #eae6f7; color: #533ea6; border: none; padding: 8px 16px; border-radius: 6px; font-size: 12px; font-weight: 700; display: flex; align-items: center; gap: 6px; cursor: pointer; transition: all 0.2s;">
            Sort by Relevance <i class="pi pi-chevron-down" style="font-size: 9px;"></i>
          </button>
          <p-overlayPanel #sortMenu [showCloseIcon]="false">
            <div class="flex flex-column gap-2 p-1" style="min-width: 140px;">
              <button (click)="applyScholarshipFilters(); sortMenu.hide()" style="background: none; border: none; text-align: left; padding: 8px; font-size: 13px; font-weight: 600; color: #0d1e70; cursor: pointer; width: 100%;">Relevance</button>
            </div>
          </p-overlayPanel>
        </div>
      </div>

      <!-- Active Filter Chips for Scholarships -->
      <div *ngIf="activeTab === 'scholarships'" style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px;">
        <ng-container *ngFor="let country of selectedCountries">
          <p-chip [label]="country" [removable]="true" (onRemove)="removeScholarshipFilterChip('country', country)" styleClass="chips"></p-chip>
        </ng-container>
        <ng-container *ngFor="let stream of selectedStreams">
          <p-chip [label]="stream" [removable]="true" (onRemove)="removeScholarshipFilterChip('stream', stream)" styleClass="chips"></p-chip>
        </ng-container>
        <ng-container *ngFor="let lvl of selectedLevels">
          <p-chip *ngIf="lvl !== 'All'" [label]="lvl" [removable]="true" (onRemove)="removeScholarshipFilterChip('level', lvl)" styleClass="chips"></p-chip>
        </ng-container>
        <ng-container *ngFor="let funding of selectedFundingTypes">
          <p-chip *ngIf="funding !== 'All'" [label]="funding" [removable]="true" (onRemove)="removeScholarshipFilterChip('funding', funding)" styleClass="chips"></p-chip>
        </ng-container>
        <ng-container *ngFor="let field of selectedFieldsOfStudy">
          <p-chip [label]="field" [removable]="true" (onRemove)="removeScholarshipFilterChip('field', field)" styleClass="chips"></p-chip>
        </ng-container>
        <p-chip *ngIf="selectedDeadline" [label]="selectedDeadline" [removable]="true" (onRemove)="removeScholarshipFilterChip('deadline')" styleClass="chips"></p-chip>
      </div>

      <!-- Wide Search input for Scholarships -->
      <div *ngIf="activeTab === 'scholarships'" style="margin-bottom: 24px; position: relative;">
        <div style="position: relative; width: 100%;">
          <i class="pi pi-search" style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 16px; z-index: 10;"></i>
          <p-autoComplete 
            [(ngModel)]="searchQuery" 
            [suggestions]="schoplarshipNames" 
            (completeMethod)="filterScholarshipNames($event)" 
            (ngModelChange)="onScholarshipSearchChange()"
            (onSelect)="applyScholarshipFilters()"
            (onClear)="applyScholarshipFilters()"
            (keyup.enter)="applyScholarshipFilters()"
            placeholder="Search"
            styleClass="w-full"
            inputStyleClass="w-full text-sm border-round-md"
            [inputStyle]="{'height': '48px', 'padding-left': '48px', 'border-radius': '8px', 'border': '1px solid #e2e8f0', 'font-size': '14px', 'font-family': '\'Karla\', sans-serif', 'box-shadow': '0 1px 2px rgba(0,0,0,0.02)', 'width': '100%'}">
          </p-autoComplete>
        </div>
      </div>

      <div *ngIf="this.loadingData">
        <div *ngIf="activeTab === 'programmes'" class="flex flex-column gap-3">
          <div *ngFor="let _ of [1, 2, 3, 4]" style="display: flex; background: #fff; border: 1px solid #e8edf2; border-radius: 12px; overflow: hidden; min-height: 240px;">
            <p-skeleton width="280px" height="100%" styleClass="flex-shrink-0"></p-skeleton>
            <div style="flex: 1; padding: 24px; display: flex; flex-direction: column; gap: 16px;">
              <p-skeleton width="60%" height="2rem"></p-skeleton>
              <p-skeleton width="40%" height="1rem"></p-skeleton>
              <div style="margin-top: 24px; display: flex; align-items: center; gap: 12px;">
                <p-skeleton width="32px" height="32px"></p-skeleton>
                <p-skeleton width="30%" height="1.5rem"></p-skeleton>
              </div>
              <div style="margin-top: auto; border-top: 1px solid #f1f5f9; padding-top: 20px; display: flex; justify-content: space-between;">
                <p-skeleton width="150px" height="20px"></p-skeleton>
                <p-skeleton width="140px" height="40px"></p-skeleton>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeTab === 'universities'" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(max(320px, calc(33.333% - 16px)), 1fr)); gap: 24px;">
          <div *ngFor="let _ of [1, 2, 3, 4, 5, 6]" style="background: white; border-radius: 12px; overflow: hidden; border: 1px solid #e2e8f0; display: flex; flex-direction: column; height: 480px;">
            <p-skeleton width="100%" height="180px"></p-skeleton>
            <div style="padding: 0 24px 24px 24px; display: flex; flex-direction: column; flex: 1;">
              <div style="width: 100px; height: 100px; margin-top: -50px; background: #fff; border: 4px solid #fff; z-index: 2; margin-bottom: 20px;">
                <p-skeleton width="100%" height="100%"></p-skeleton>
              </div>
              <p-skeleton width="70%" height="2rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="40%" height="1rem" styleClass="mb-4"></p-skeleton>
              <div style="display: flex; flex-direction: column; gap: 14px; margin-top: auto; margin-bottom: 32px;">
                <p-skeleton width="50%" height="1.2rem"></p-skeleton>
                <p-skeleton width="60%" height="1.2rem"></p-skeleton>
                <p-skeleton width="55%" height="1.2rem"></p-skeleton>
              </div>
              <div style="display: flex; gap: 12px;">
                <p-skeleton width="100%" height="48px"></p-skeleton>
                <p-skeleton width="100%" height="48px"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div [hidden]="this.loadingData">
        <div *ngIf="activeTab === 'programmes'">
        <p-dataView styleClass="dataview" [alwaysShowPaginator]="false" [value]="institutes()"
          [showCurrentPageReport]="true" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false"
          [rows]="rowSize" emptyMessage="No Records Found !" [paginator]="true" [totalRecords]="total"
          [first]="firstItem" [rowsPerPageOptions]="[9,18,27,36,45]" currentPageReportTemplate="{currentPage} of {totalPages}">
          <ng-template pTemplate="list" let-items>
            <div class="flex flex-column gap-3">
              <div *ngFor="let institute of items; let i = index; trackBy: trackByInstituteId">
                <app-institute-search-item [item]="institute" [portal]="portal" [isCourseView]="true"
                  [programmeHeading]="filterComponent?.getActiveCourseLabel() || null"
                  (myInstituteEmitter)="toggleMyInstitute($event, institute.isMyInstitute, i)"
                  (directApplyEmitter)="addToDirectApply($event, i)"
                  [loading]="loadingInstituteId === institute.id" [isInstituteSaved]="institute.isMyInstitute"
                  [isDirectApplied]="checkIfDirectApplied(institute.id, institute.courseId)">
                </app-institute-search-item>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </div>

      <div *ngIf="activeTab === 'universities'">
        <p-dataView styleClass="dataview" [alwaysShowPaginator]="false" [value]="institutes()"
          [showCurrentPageReport]="true" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false"
          [rows]="rowSize" emptyMessage="No Records Found !" [paginator]="true" [totalRecords]="total"
          [first]="firstItem" [rowsPerPageOptions]="[9,18,27,36,45]" currentPageReportTemplate="{currentPage} of {totalPages}">
          <ng-template pTemplate="list" let-items>
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(max(320px, calc(33.333% - 16px)), 1fr)); gap: 24px;">
              <div *ngFor="let institute of items; let i = index; trackBy: trackByInstituteId">
                <app-institute-search-item [item]="institute" [portal]="portal" [isCourseView]="false"
                  (myInstituteEmitter)="toggleMyInstitute($event, institute.isMyInstitute, i)"
                  (directApplyEmitter)="addToDirectApply($event, i)"
                  [loading]="loadingInstituteId === institute.id" [isInstituteSaved]="institute.isMyInstitute"
                  [isDirectApplied]="checkIfDirectApplied(institute.id, institute.courseId)">
                </app-institute-search-item>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </div>

      <div *ngIf="activeTab === 'scholarships'">
        <p-dataView styleClass="dataview" [alwaysShowPaginator]="false" [value]="scholarshipsList()"
          [showCurrentPageReport]="true" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false"
          [rows]="8" emptyMessage="No Records Found !" [paginator]="true" [totalRecords]="total"
          [first]="firstItem" [rowsPerPageOptions]="[8,16,24,32,40]">
          <ng-template pTemplate="list" let-items>
            <div class="grid w-full m-0" style="row-gap: 24px;">
              <ng-container *ngFor="let item of items; let i = index;">
                
                <!-- Insert promotional banner as the 4th item (index 3) -->
                <div *ngIf="i === 3" class="col-12 sm:col-6 md:col-4 p-2">
                  <div class="flex flex-column p-4 border-round-xl justify-content-between"
                       style="background: linear-gradient(135deg, #0b153b 0%, #050b1e 100%); border-radius: 16px; height: 100%; min-height: 335px; box-shadow: 0 4px 6px rgba(0,0,0,0.05); color: #fff; font-family: 'Karla', sans-serif;">
                    
                    <div class="flex flex-column gap-3">
                      <div>
                        <span style="background: rgba(255,255,255,0.08); color: #CDD12A; padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; gap: 6px; font-family: 'Circular Std', sans-serif;">
                          <span style="width: 6px; height: 6px; background-color: #3b82f6; border-radius: 50%;"></span> SCHOLARSHIP FINDER
                        </span>
                      </div>

                      <h3 style="font-family: 'Circular Std', sans-serif; font-size: 20px; font-weight: 700; margin: 0; color: #fff; line-height: 1.35;">
                        Not seeing what <span style="color: #CDD12A;">you're looking for?</span>
                      </h3>

                      <p style="font-size: 12.5px; line-height: 1.6; color: #cbd5e1; margin: 0; font-weight: 500;">
                        Search across our full database by country and find the right fit in minutes.
                      </p>
                    </div>

                    <!-- Button -->
                    <button (click)="exploreAllScholarships()" 
                            style="width: 100%; padding: 12px; background-color: #CDD12A; color: #0b153b; border: none; border-radius: 8px; font-family: 'Circular Std', sans-serif; font-size: 13px; font-weight: 700; cursor: pointer; transition: all 0.2s; text-align: center; box-shadow: 0 4px 12px rgba(205, 209, 42, 0.2); margin-top: auto; display: flex; align-items: center; justify-content: center; gap: 6px;">
                      Explore All Scholarships <i class="pi pi-arrow-right" style="font-size: 11px;"></i>
                    </button>
                  </div>
                </div>

                <!-- Main scholarship card -->
                <div class="col-12 sm:col-6 md:col-4 p-2">
                  <div class="scholarship-card flex flex-column bg-white border-round-xl p-4"
                       style="border: 1px solid #e8edf2; border-radius: 16px; overflow: visible; height: 100%; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02), 0 2px 4px -1px rgba(0,0,0,0.01); transition: transform 0.2s, box-shadow 0.2s; font-family: 'Karla', sans-serif; position: relative;"
                       (click)="openScholarshipDetails(item)">
                    
                    <!-- Top Row: Avatar on left, Deadline Badge and Heart Save Button on right -->
                    <div class="flex justify-content-between align-items-start mb-3 w-full" style="position: relative;">
                      <!-- Avatar circle with overlapping country flag -->
                      <div style="position: relative; width: 72px; height: 72px; flex-shrink: 0;">
                        <div style="width: 72px; height: 72px; border-radius: 50%; overflow: hidden; border: 1.5px solid #e2e8f0; background: #fafafa; display: flex; align-items: center; justify-content: center;">
                          <img *ngIf="getScholarshipImage(item)" [src]="getScholarshipImage(item)" style="width: 100%; height: 100%; object-fit: cover;" />
                          <i *ngIf="!getScholarshipImage(item)" class="pi pi-graduation-cap text-3xl" style="color: #0d1e70;"></i>
                        </div>
                        <!-- Overlapping Flag badge at bottom right -->
                        <div style="position: absolute; bottom: -2px; right: -2px; width: 26px; height: 26px; border-radius: 50%; border: 2.5px solid #fff; overflow: hidden; background: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1); z-index: 2;">
                          <img *ngIf="getCountryFlag(item.country)" [src]="getCountryFlag(item.country)" style="width: 100%; height: 100%; object-fit: cover;" />
                          <i *ngIf="!getCountryFlag(item.country)" class="pi pi-globe text-blue-500 text-sm"></i>
                        </div>
                      </div>

                      <div class="flex align-items-center gap-2">
                        <!-- Deadline Badge -->
                        <div style="background-color: #eff6ff; color: #3b82f6; padding: 6px 12px; border-radius: 12px; font-size: 11px; font-weight: 700; font-family: 'Circular Std', sans-serif;">
                          Deadline : {{ item.deadLine?.month ? formatMonth(item.deadLine.month) : 'Varies' }}
                        </div>

                        <!-- Save Heart Button -->
                        <button (click)="toggleMyScholarship(item.id); $event.stopPropagation()"
                                [style.color]="item.isMyScholarship ? '#ef4444' : '#94a3b8'"
                                style="width: 28px; height: 28px; border-radius: 50%; border: 1px solid #e2e8f0; background: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.2s; flex-shrink: 0;">
                          <i class="pi" [ngClass]="item.isMyScholarship ? 'pi-heart-fill' : 'pi-heart'" style="font-size: 13px;"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Middle Text: Title and Organization -->
                    <div class="flex flex-column mb-3" style="flex: 1;">
                      <b class="text-left font-bold text-base line-height-2" style="color: #0d1e70; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; height: 40px; font-family: 'Circular Std', sans-serif; font-size: 15px; margin-bottom: 2px;">
                        {{ item.name }}
                      </b>
                      <span class="text-xs text-gray-500" style="font-weight: 600; display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-family: 'Karla', sans-serif;">
                        {{ item.universityOrOrganisationName || 'Varies' }}
                      </span>
                    </div>

                    <!-- Metadata List with Icons -->
                    <div class="flex flex-column gap-2 mb-4">
                      <div class="flex align-items-center gap-2 text-xs text-gray-600">
                        <i class="pi pi-map-marker" style="color: #94a3b8; font-size: 13px; width: 14px;"></i>
                        <span>{{ item.country ? item.country[0] : 'Varies' }}</span>
                      </div>
                      <div class="flex align-items-center gap-2 text-xs text-gray-600">
                        <i class="pi pi-wallet" style="color: #94a3b8; font-size: 13px; width: 14px;"></i>
                        <span class="font-bold" style="color: #1e293b;">{{ getFormattedAmount(item) }}</span>
                      </div>
                      <div class="flex align-items-center gap-2 text-xs text-gray-600">
                        <i class="pi pi-graduation-cap" style="color: #94a3b8; font-size: 13px; width: 14px;"></i>
                        <span>{{ item.level || 'Any' }}</span>
                      </div>
                    </div>

                    <!-- Buttons Row -->
                    <div style="display: flex; gap: 8px; font-family: 'Circular Std', sans-serif;">
                      <button (click)="openScholarshipDetails(item); $event.stopPropagation()" 
                              style="flex: 1; padding: 10px; background: #fff; border: 1.5px solid #0d1e70; color: #0d1e70; border-radius: 8px; font-size: 12px; font-weight: 700; cursor: pointer; transition: all 0.2s;">
                        View Details
                      </button>
                      <button (click)="shareWithMentorDirect(item); $event.stopPropagation()" 
                              style="flex: 1; padding: 10px; background: #0d1e70; border: none; color: #fff; border-radius: 8px; font-size: 12px; font-weight: 700; cursor: pointer; transition: all 0.2s;">
                        Share with Mentor
                      </button>
                    </div>
                  </div>
                </div>

              </ng-container>
            </div>
          </ng-template>
        </p-dataView>
      </div>
      </div>
    </div>
  </div>

  <!-- Bottom Clarity Call Banner -->
  <div *ngIf="activeTab === 'scholarships'" class="clarity-banner-container border-round-3xl shadow-3 relative overflow-hidden">
    <!-- Glow Accent (Right) -->
    <div class="glow-accent absolute"></div>

    <!-- Left Illustration -->
    <div class="illustration-col">
      <img src="assets/images/Group 716.png" 
           alt="Team building blocks illustration" 
           class="banner-illustration">
    </div>

    <!-- Middle Message -->
    <div class="text-col text-white">
      <h2 class="font-bold text-3xl md:text-4xl m-0 leading-height-2">
        Not sure which Scholarship is right <span class="neon-yellow-text">for your goals?</span>
      </h2>
      <p class="m-0 text-sm md:text-md line-height-3 text-gray-200">
        Book a call with one of our peers or your mentor so they can point you in the right direction.
      </p>
    </div>

    <!-- Right CTA Button -->
    <div class="button-col">
      <button class="p-link book-call-btn" (click)="bookClarityCall()">
        Book My Clarity Call
      </button>
    </div>
  </div>
</div>

<!-- Scholarship Details Dialog overlay -->
<p-dialog [(visible)]="scholarshipDialogVisible" [modal]="true" [showHeader]="false"
  styleClass="scholarship-details-dialog-panel"
  [style]="{width: '850px', 'max-width': '95vw', 'max-height': '90vh', 'border-radius': '24px', 'overflow': 'hidden', 'padding': '0'}"
  [contentStyle]="{'padding': '0'}" (onHide)="closeScholarshipDialog()">

  <div class="w-full flex flex-column" *ngIf="selectedScholarship" style="background-color: white; max-height: 90vh;">
    <!-- Header Section -->
    <div class="dialog-header">
      <!-- Close Button -->
      <button class="dialog-close-btn" (click)="closeScholarshipDialog()">
        <i class="pi pi-times"></i>
      </button>

      <!-- Icon & Title -->
      <div class="dialog-title-container">
        <div class="dialog-icon-box">
          <i class="pi pi-graduation-cap"></i>
        </div>
        <h2 class="dialog-title">
          {{selectedScholarship.name}}
        </h2>
      </div>

      <!-- Pills Row -->
      <div class="dialog-pills-row">
        <!-- Pill 1: Country -->
        <div class="dialog-pill">
          <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-pill-flag" />
          <i *ngIf="!getCountryFlag(selectedScholarship.country)" class="pi pi-globe"></i>
          <span>{{getCountryPillName(selectedScholarship.country)}}</span>
        </div>
        <!-- Pill 2: Organization -->
        <div class="dialog-pill">
          <i class="pi pi-home"></i>
          <span>{{selectedScholarship.universityOrOrganisationName || 'Varies'}}</span>
        </div>
        <!-- Pill 3: Deadline -->
        <div class="dialog-pill">
          <i class="pi pi-clock"></i>
          <span>Closes {{getDeadlineDisplay(selectedScholarship.deadLine)}}</span>
        </div>
      </div>
    </div>

    <!-- Scrollable Content Area -->
    <div class="w-full overflow-y-auto overflow-x-hidden" style="flex: 1; background-color: #ffffff;">
      <div class="dialog-body-container">
        <div class="dialog-grid">
          <!-- Left Column: Overview & Eligibility -->
          <div class="dialog-left-col">
            
            <!-- OVERVIEW Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Overview</span>
              
              <div class="dialog-list">
                <!-- Row 1: Country -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-map-marker"></i>
                    </div>
                    <span>Country</span>
                  </div>
                  <div class="dialog-row-value">
                    <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-row-flag" />
                    <span>{{selectedScholarship.country ? getCountryDisplayName(selectedScholarship.country) : 'Global'}}</span>
                  </div>
                </div>

                <!-- Row 2: Organization -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-home"></i>
                    </div>
                    <span>Organization</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="selectedScholarship.universityOrOrganisationName || 'Varies'">
                    {{selectedScholarship.universityOrOrganisationName || 'Varies'}}
                  </div>
                </div>

                <!-- Row 3: Stream -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-book"></i>
                    </div>
                    <span>Stream</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="getStreamDisplayName(selectedScholarship.stream)">
                    {{getStreamDisplayName(selectedScholarship.stream)}}
                  </div>
                </div>

                <!-- Row 4: Level -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-graduation-cap"></i>
                    </div>
                    <span>Level</span>
                  </div>
                  <div class="dialog-row-value">
                    {{getLevelDisplayName(selectedScholarship.level)}}
                  </div>
                </div>
              </div>
            </div>

            <!-- ELIGIBILITY Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Eligibility</span>
              
              <div class="dialog-list">
                <!-- Row 1: Nationality -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-flag"></i>
                    </div>
                    <span>Nationality</span>
                  </div>
                  <div class="dialog-row-value">
                    {{selectedScholarship.eligibility?.nationality || 'Check Eligibility'}}
                  </div>
                </div>

                <!-- Row 2: Academic Requirements -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-file"></i>
                    </div>
                    <span>Academic</span>
                  </div>
                  <div class="dialog-row-value-double">
                    <span class="dialog-val-main">{{getAcademicMainText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                    <span class="dialog-val-sub" *ngIf="getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)">{{getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                  </div>
                </div>

                <!-- Row 3: Others -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-info-circle"></i>
                    </div>
                    <span>Other</span>
                  </div>
                  <div class="dialog-row-value" [class.no-criteria]="!selectedScholarship.eligibility?.others">
                    {{selectedScholarship.eligibility?.others || 'No additional criteria'}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column: What's Covered (Lime Gradient Box) -->
          <div class="dialog-right-col">
            <span class="dialog-section-title">What's Covered</span>
            
            <div class="gradient-card">
              <!-- Funding Amount row -->
              <div class="card-funding-header">
                <div class="funding-icon-box">
                  <i class="pi pi-search"></i>
                </div>
                <div class="funding-text-box">
                  <span class="funding-label">Funding</span>
                  <span class="funding-value">{{getFormattedAmount(selectedScholarship)}}</span>
                </div>
              </div>

              <!-- Coverage checklist items -->
              <div class="card-checklist">
                <div class="checklist-item" [class.not-covered]="!isCovered('tuition')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Tuition covered</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('living')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Living expenses</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('travel')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Travel cost</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('health')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Health insurance</span>
                </div>
              </div>

              <!-- Dotted Divider -->
              <div class="card-divider"></div>

              <!-- Coverage type row -->
              <div class="card-coverage-footer">
                <span class="coverage-label">Coverage type</span>
                <div class="coverage-pill">
                  {{ getCoverageType() }}
                </div>
              </div>
            </div>
            
            <!-- Illustration below the card -->
            <div class="dialog-illustration-box" style="display: flex; justify-content: center; margin-top: 16px; padding-top: 8px;">
              <img src="assets/images/Group 43057.png" alt="What's Covered Illustration" style="max-width: 100%; height: auto; max-height: 180px; display: block;" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer buttons section -->
    <div class="dialog-footer">
      <!-- Left side: Deadline and link -->
      <div class="dialog-footer-left">
        <!-- Deadline badge -->
        <div class="dialog-deadline-badge">
          <div class="deadline-icon-box">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div class="deadline-text-box">
            <span class="deadline-label">Deadline</span>
            <span class="deadline-value">
              {{getDeadlineDisplay(selectedScholarship.deadLine)}}
            </span>
          </div>
        </div>

        <!-- Application Link -->
        <a [href]="selectedScholarship.applicationLink" target="_blank"
           class="dialog-app-link"
           *ngIf="selectedScholarship.applicationLink">
          Application Link <i class="pi pi-arrow-up-right"></i>
        </a>
      </div>

      <!-- Right side: Save and Share buttons -->
      <div class="dialog-footer-right">
        <!-- Save bookmark button (heart style) -->
        <button (click)="toggleMyScholarship(selectedScholarship.id)" class="dialog-bookmark-btn" [style.color]="selectedScholarship.isMyScholarship ? '#ef4444' : '#94a3b8'">
          <i class="pi" [ngClass]="selectedScholarship.isMyScholarship ? 'pi-heart-fill' : 'pi-heart'"></i>
        </button>

        <!-- Share with mentor button -->
        <button (click)="shareMenu.toggle($event)" class="dialog-share-btn">
          Share with mentor
        </button>
      </div>

      <!-- Mentor Share overlay panel inside the footer -->
      <p-overlayPanel #shareMenu [showCloseIcon]="false">
        <div class="flex flex-column gap-2 p-1" style="min-width: 200px;">
          <b class="text-xs font-bold text-gray-500 mb-2 uppercase tracking-wider">Share with</b>

          <ng-container *ngIf="studentMentors.length > 0; else noMentorMenuTemplate">
            <div *ngFor="let mentor of studentMentors"
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-blue-50 transition-colors"
              (click)="selectedMentorToShare = mentor; shareScholarshipWithMentor(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">{{mentor.label}}</span>
                <span class="text-xs text-gray-500">Your Mentor</span>
              </div>
            </div>
          </ng-container>

          <ng-template #noMentorMenuTemplate>
            <div
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-orange-50 transition-colors"
              (click)="navigateToMentors(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">No Mentor Found</span>
                <span class="text-xs text-blue-600 font-medium">Choose your mentor</span>
              </div>
            </div>
          </ng-template>
        </div>
      </p-overlayPanel>
    </div>
  </div>
</p-dialog>


<app-clarity-call-popup
  [(visible)]="showClarityCallDialog"
  [contactPurpose]="13">
</app-clarity-call-popup>